import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigate } from './navigationService';

// Component to initialize navigation service with useNavigate hook
const NavigationProvider = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Initialize the navigation service with the navigate function
    setNavigate(navigate);
  }, [navigate]);

  return children;
};

export default NavigationProvider;